import AccettazioneSsnEditViewPage from "./pages/AccettazioneSsnEditViewPage.vue";
import AccettazioneSsnListaPage from "./pages/AccettazioneSsnListaPage.vue";
import AccettazionePrenotazioniLazioListPage from "./pages/AccettazionePrenotazioniLazioListPage.vue";
import AccettazioneSsnGruppiConfigListPage from "./pages/AccettazioneSsnGruppiConfigListPage.vue";
import AccettazioneRicettaPrestazioniListaPage from "../ricettaprestazioniappuntamenti/pages/AccettazioneRicettaPrestazioniListaPage.vue";
import AccettazionePrestazioniAppuntamentiAccessiListPage from "../appuntamenti/pages/AccettazionePrestazioniAppuntamentiAccessiListPage.vue";
import AccettazioneSsnRiepilogoImpegnativeListPage from "../appuntamenti/pages/AccettazioneSsnRiepilogoImpegnativeListPage.vue";

export default {
    AccettazioneSsnEditViewPage,
    AccettazioneSsnListaPage,
    AccettazionePrenotazioniLazioListPage,
    AccettazioneSsnGruppiConfigListPage,
    AccettazioneRicettaPrestazioniListaPage,
    AccettazionePrestazioniAppuntamentiAccessiListPage,
    AccettazioneSsnRiepilogoImpegnativeListPage,
};
